import { token, me } from "@/api/auth";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    region: "",
    roles: [],
    selectedContentId: 0,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    // state.token = token;
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_USER_ROLE: (state, role) => {
    state.role = role;
  },
  SET_REGION: (state, region) => {
    state.region = region;
  },
  SET_SITE_URL: (state, siteUrl) => {
    state.siteUrl = siteUrl;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_CURRENT_CONTENT_ID: (state, contentId) => {
    state.selectedContentId = contentId;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    // const { login, password } = userInfo;
    return new Promise((resolve, reject) => {
      // const params = new URLSearchParams();

      // params.append("login", login.trim());
      // params.append("password", password);
      token(userInfo)
        .then((resp) => {
          commit("SET_TOKEN", resp.access_token);
          setToken(resp.access_token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      me()
        .then((resp) => {
          const roles = [`${resp.role}`];
          const { name = resp.name, region = resp.city, site_url = "" } = resp;

          commit("SET_ROLES", roles);
          commit("SET_NAME", name);
          commit("SET_REGION", region);
          commit(
            "SET_SITE_URL",
            process.env.VUE_APP_SITE_URL
              ? process.env.VUE_APP_SITE_URL
              : site_url
          );

          resolve({ roles, name, region });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    removeToken(); // must remove  token  first
    resetRouter();
    commit("RESET_STATE");
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },

  setCurrentContentId({ commit }) {
    commit("SET_CURRENT_CONTENT_ID");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
